import { useMutation } from 'react-query';
import * as chatService from 'services/chatService';

export const useSendProductChatMessage = (
  onSuccess?: (response: string) => void,
  onError?: (error: any) => void,
  options = {}
) => {
  return useMutation(chatService.sendProductChatMessage, {
    onSuccess,
    onError,
    ...options,
  });
};

export const useClearProductChat = (
  onSuccess?: () => void,
  onError?: (error: any) => void,
  options = {}
) => {
  return useMutation(chatService.clearProductChat, {
    onSuccess,
    onError,
    ...options,
  });
};
